// src/store/useLanguageStore.js

import { defineStore } from 'pinia';

export const useLanguageStore = defineStore('language', {
  state: () => ({
    selectedLanguage: 'TH' 
  }),
  actions: {
    setLanguage(lang) {
      this.selectedLanguage = lang;
    }
  }
});
